import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-avatar',
  imports: [CommonModule],
  template: `
    <div class="av" [style.width.px]="size" [style.height.px]="size"
         [style.borderRadius.px]="circle ? size : size * 0.28"
         [style.fontSize.px]="size * 0.38"
         [style.background]="src ? '#eee' : gradient">
      <img *ngIf="src" [src]="src" class="av-img" alt="">
      <span *ngIf="!src">{{ initials }}</span>
    </div>
  `,
  styles: [`
    .av { display: grid; place-items: center; color: #fff; font-weight: 700; flex-shrink: 0;
          overflow: hidden; letter-spacing: .3px; }
    .av-img { width: 100%; height: 100%; object-fit: cover; }
  `],
})
export class AvatarComponent {
  @Input() name = '';
  @Input() src: string | null = null;
  @Input() size = 38;
  @Input() circle = false;

  get initials(): string {
    const parts = (this.name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    return ((parts[0][0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
  }

  get gradient(): string {
    let h = 0;
    const s = this.name || '?';
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
    return `linear-gradient(135deg, hsl(${h},55%,52%), hsl(${(h + 40) % 360},55%,42%))`;
  }
}
